var u = Object.defineProperty;
var S = (n, t, e) => t in n ? u(n, t, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: e
}) : n[t] = e;
var r = (n, t, e) => S(n, typeof t != "symbol" ? t + "" : t, e);
import { PersistentConnection as C, initializeStore as p } from "@seamless/store";
const c = "DH-IO-OWCC_REGION_PICKER_CONNECTION",
  l = "LOAD_PERSISTED_STATE",
  h = "SET_REGION ",
  d = "SET_OPENSTATE",
  y = "local",
  g = {
    region: "",
    isOpen: !1
  },
  E = (n = g, t) => {
    switch (t.type) {
      case `${c}/${l}`:
        return console.log(t), {
          ...n,
          region: t.payload.region
        };
      case `${c}/${h}`:
        return {
          ...n,
          region: t.payload
        };
      case `${c}/${d}`:
        return {
          ...n,
          isOpen: t.payload
        };
      default:
        return n;
    }
  },
  o = class o extends C {
    constructor(e) {
      super(c);
      r(this, "seamlessCoreStore", p());
      r(this, "connectionAlreadyAdded", !1);
      r(this, "cachedConnectionDispatchers", null);
      r(this, "countryCode");
      this.countryCode = e;
    }
    async onBeforeRegister(e) {
      const s = await this.transformToPersistentState(this.initialState),
        i = this.loadPersistedStateCallback(s);
      i != null && e(i), await this.storeState(s);
    }
    static getInstance(e) {
      return o.instance || (o.instance = new o(e)), o.instance;
    }
    get initialState() {
      const e = `swsp:${this.name}`;
      return localStorage.getItem(e) ? JSON.parse(localStorage.getItem(e)) : g;
    }
    get storageType() {
      return y;
    }
    getStoreReference() {
      return this.seamlessCoreStore;
    }
    getReducer() {
      return E;
    }
    getPublicDispatchers() {
      return {
        setRegion: e => async s => {
          s(this.getAction(h, e));
        },
        setOpenState: e => async s => {
          s(this.getAction(d, e));
        }
      };
    }
    async getRegisteredDispatchers() {
      if (!this.connectionAlreadyAdded) {
        try {
          await this.seamlessCoreStore.addConnection(this).catch(e => {
            console.log(e);
          });
        } catch (e) {
          console.log(e);
        }
        this.connectionAlreadyAdded = !0;
      }
      return this.cachedConnectionDispatchers || (this.cachedConnectionDispatchers = await this.seamlessCoreStore.getConnectionDispatchers(c)), this.cachedConnectionDispatchers;
    }
    loadPersistedStateCallback(e) {
      var s, i;
      return this.getAction(l, {
        region: ((s = this.countryCode) == null ? void 0 : s.toLowerCase()) === ((i = e == null ? void 0 : e.countryCode) == null ? void 0 : i.toLowerCase()) ? e.region : ""
      });
    }
    async transformToPersistentState(e) {
      return {
        region: e.region,
        isOpen: e.isOpen,
        countryCode: this.countryCode,
        fromPersistFunction: !0
      };
    }
  };
r(o, "instance");
let a = o;
const A = n => a.getInstance(n);
export { c as connectionName, A as getRegionPickerConnection };
